<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="题目分类：">
         <el-select v-model="query.topicClassificationId" placeholder="请选择" clearable size="small">
              <el-option v-for="(item,index) in topicClassOptions" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import courseExamRecordsApi from '@/api/course/courseExamRecords'
import courseTopicClassificationApi from '@/api/course/courseTopicClassification'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        topicClassificationId: undefined
      },
      topicClassOptions: [],  
    }
  },
  created() {
    this.getSelectOptions()
  },
  methods: {
    getSelectOptions() {
      courseTopicClassificationApi.fetchOptions().then(({ data }) => this.topicClassOptions = data)
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    handleDownload() {
      this.query.createdTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.createdTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
     
      return this.$common.confirm('是否确认导出')
        .then(() => courseExamRecordsApi.exportExcel2(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>